import { render, staticRenderFns } from "./betParlayModal.vue?vue&type=template&id=2b3d9820&scoped=true&lang=pug&"
import script from "./betParlayModal.vue?vue&type=script&lang=js&"
export * from "./betParlayModal.vue?vue&type=script&lang=js&"
import style0 from "./betParlayModal.vue?vue&type=style&index=0&id=2b3d9820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3d9820",
  null
  
)

export default component.exports